import { useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'react-feather';
import TablaServidor from '../../components/tabla/TablaServidor';
import { AuthContext } from '../../context/authContext';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import { getItem, removeItem, STORAGE_KEYS } from '../../services/storage';
import {
  COLUMNAS_SOLICITUDES,
  COLUMNAS_MATRICULAS_MODULOS,
  TABLA_SOLICITUDES,
  TABLA_MATRICULAS_MODULOS,
} from '../../components/matriculas/columnasMatriculas';

const FILTROS_MATRICULAS = [
  'estado',
  'empresaId',
  'centro',
  'ciclo',
  'anyo',
  'curso',
  'nombre_grupo',
];
const FILTROS_MODULOS = [
  'estado',
  'empresaId',
  'centro',
  'ciclo',
  'modulo',
  'anyo',
  'nombre_grupo',
];

const VISTAS = [
  { id: 'matriculas', etiqueta: 'Por matrícula' },
  { id: 'modulos', etiqueta: 'Por módulo' },
];

const selector = (activo) => ({
  padding: '6px 14px',
  fontSize: '0.8125rem',
  fontWeight: 600,
  cursor: 'pointer',
  border: '1px solid #e5e7eb',
  borderRadius: '8px',
  background: activo ? '#eaf0ff' : '#fff',
  color: activo ? '#1a46cc' : '#475569',
});

const Solicitudes = () => {
  useTituloCabecera('Matrículas', 'Solicitudes de matrícula y matrículas por módulo');
  const navigate = useNavigate();
  const { userOU } = useContext(AuthContext);
  const [vista, setVista] = useState('matriculas');
  const [soloDeudores, setSoloDeudores] = useState(false);

  // La delegación del usuario acota lo que ve (≤ 0 = sin restricción).
  const params = useMemo(
    () => ({
      idDelegacion: userOU?.idCedesca,
      idDelegacionCntec: userOU?.idCntec,
      deudor: soloDeudores ? 'true' : undefined,
    }),
    [userOU, soloDeudores],
  );

  const abrir = (fila) => {
    if (getItem(STORAGE_KEYS.ENROLLMENT)) removeItem(STORAGE_KEYS.ENROLLMENT);
    navigate(
      `/solicitudes-matricula/${String(fila.empresaId).toLowerCase()}/${
        fila.num_matricula
      }/revision`,
    );
  };

  const accionDetalles = (fila) => (
    <button
      type="button"
      className="tbl-icono"
      aria-label="Detalles"
      title="Ver detalles"
      onClick={(e) => {
        e.stopPropagation();
        abrir(fila);
      }}
    >
      <ArrowRight size={15} />
    </button>
  );

  const barraExtra = (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: '0.8125rem',
        color: '#475569',
      }}
    >
      <input
        type="checkbox"
        checked={soloDeudores}
        onChange={(e) => setSoloDeudores(e.target.checked)}
      />
      Solo deudores
    </label>
  );

  return (
    <div>
      <div role="tablist" style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        {VISTAS.map((v) => (
          <button
            key={v.id}
            type="button"
            role="tab"
            aria-selected={vista === v.id}
            onClick={() => setVista(v.id)}
            style={selector(vista === v.id)}
          >
            {v.etiqueta}
          </button>
        ))}
      </div>

      {vista === 'matriculas' ? (
        <TablaServidor
          key="matriculas"
          tablaKey={TABLA_SOLICITUDES}
          columnas={COLUMNAS_SOLICITUDES}
          ruta="solicitudes"
          archivo="solicitudes-matricula"
          nombreEntidad="matrículas"
          placeholder="Buscar por nombre, apellidos, DNI, email, grupo o nº de matrícula…"
          params={params}
          filtrosRapidos={FILTROS_MATRICULAS}
          barraExtra={barraExtra}
          onFilaClick={abrir}
          renderAcciones={accionDetalles}
          claveFila={(f) => `${f.empresaId}-${f.num_matricula}`}
          tituloTarjeta={(f) =>
            `#${f.num_matricula} · ${f.nombre || ''} ${f.apellidos || ''}`.trim()
          }
        />
      ) : (
        <TablaServidor
          key="modulos"
          tablaKey={TABLA_MATRICULAS_MODULOS}
          columnas={COLUMNAS_MATRICULAS_MODULOS}
          ruta="matriculas-modulos"
          archivo="matriculas-por-modulo"
          nombreEntidad="matrículas por módulo"
          placeholder="Buscar por módulo, código, grupo, alumno, DNI o nº de matrícula…"
          params={params}
          filtrosRapidos={FILTROS_MODULOS}
          barraExtra={barraExtra}
          onFilaClick={abrir}
          renderAcciones={accionDetalles}
          tituloTarjeta={(f) => `${f.modulo || ''} · ${f.nombre || ''} ${f.apellidos || ''}`.trim()}
        />
      )}
    </div>
  );
};

export default Solicitudes;
